module.exports = __webpack_public_path__ + "static/media/qyj2_hg_5000_03.8b375b0b.png";